import { Grid, makeStyles, Typography, useMediaQuery, useTheme } from "@material-ui/core"
import ProdutoCard from "./ProdutoCard"

const useStyles = makeStyles({
    categoria: {
        maxWidth: "100%",
        padding: "0px!important",
        margin: "0 0 2em 0",
    },
})

function CategoriaGrid({
    categoria,
    layout,
    selecionarProduto,
    removerProdutoCarrinho,
    adicionarProdutoCarrinho,
    numberoProdutoCarrinho,
}) {
    //TODO: ATIVO? RETURN NULL

    const classes = useStyles()

    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down("xs"))

    if (categoria.produtos.length === 0) return null

    return (
        <Grid container item fullWidth spacing={2} className={classes.categoria} id={"categoria-" + categoria.id}>
            <Grid item xs={12}>
                <Typography variant="h5" component="span">
                    {categoria.nome}
                </Typography>
            </Grid>
            <Grid container item spacing={isMobile ? 1 : 2}>
                {categoria.produtos.map((produto, index) => (
                    <ProdutoCard
                        key={index}
                        produto={produto}
                        layout={layout}
                        removerProdutoCarrinho={removerProdutoCarrinho}
                        adicionarProdutoCarrinho={adicionarProdutoCarrinho}
                        numberoProdutoCarrinho={numberoProdutoCarrinho}
                        selecionarProduto={selecionarProduto}
                    />
                ))}
            </Grid>
        </Grid>
    )
}

export default CategoriaGrid
